import { CommonModule } from '@angular/common';
import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import {  ListTableComponent  } from '@ppl/ui';
import { DatePickerModule } from 'primeng/datepicker';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { TimesheetFilterComponent } from '../timesheet-filter/timesheet-filter.component';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { LookupService } from '../../../../services/lookup.service';
import { UserService } from '../../../../services/user.service';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { DialogService, DialogConfig } from '../../../../shared/services/dialog.service';
import { ErrorAlertService } from '../../../../shared/services/error-alert.service';
import { ListService } from '../../../../shared/services/list.service';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';
import CommonUtil from '../../../../shared/authorization/common.util';
import { TimesheetAdjustVoidEntryComponent } from '../timesheet-adjust-void-entry/timesheet-adjust-void-entry.component';
import { TimesheetStaffDeniedReasonsComponent } from '../timesheet-staff-deniedreasons/timesheet-staff-deniedreasons.component';
import { environment } from '../../../../../environments/environment';
import { AllowListAuthStore } from '../../../../shared/authorization/allow-list-auth.store';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';

@Component({
  selector: 'ppl-timesheet-payroll-resurrect',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroModule,
    NzDatePickerModule,
    DatePickerModule,
    ListTableComponent,
    TimesheetFilterComponent,
    TimesheetStaffDeniedReasonsComponent,
    TimesheetAdjustVoidEntryComponent
  ],
  templateUrl: './timesheet-payroll-resurrect.component.html',
  styleUrl: './timesheet-payroll-resurrect.component.css'
})
export class TimesheetPayrollResurrectComponent {
  private allowListStore = inject(AllowListAuthStore);
  pageId = PAGE_CONSTANTS.STAFF_PAYROLL_RESURRECT;
  isReadOnly = false;
  @ViewChild(ListTableComponent) childComponent!: ListTableComponent;
  @ViewChild(TimesheetFilterComponent) timesheetFilterChildComponent!: TimesheetFilterComponent;
  @ViewChild('deniedDialog') deniedDialog!: TemplateRef<any>;
  @ViewChild('timesheetResurrectDialog') timesheetResurrectDialog!: TemplateRef<any>;
  @ViewChild('searchFilterWarningDialog') searchFilterWarningDialog!: TemplateRef<any>;

  private dialogSvc = inject(DialogService);

  actionButtons: TableRowActionsModel = new TableRowActions({ view: false });
  appliedFilters: any;
  businessStatusList: any;
  deniedData: any;
  resurrectDeniedDialog: any;
  dispositionReason: any;
  programName!: string;
  processingStatusList: any;
  resurrectDialog: any;
  selectedAction: any;
  serviceCodes: LookupValueItem[] = [];
  timesheets: any[] = [];
  hasSearched = false;
  timesheetData: any = {};
  timesheetDisposition: any;

  buttons = [
    {
      button_id: "Resurrect",
      button_label: "Resurrect",
      buttonAction: "resurrectTimesheet",
      className: "primary-btn-color"
    },
    {
      button_id: "ResurrectAll",
      button_label: "Resurrect All",
      buttonAction: "resurrectAllTimesheet",
      className: "primary-btn-color"
    }
  ];

  cols = [
    {
      field: 'serviceDate',
      header: 'Service \nDate',
      jsonpath: 'serviceDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceDescription',
      header: 'Service \nCode',
      jsonpath: 'serviceDescription',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'authDesc',
      header: 'Service \nDescription',
      jsonpath: 'authDesc',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'consumerName',
      header: 'Participant \nName',
      jsonpath: 'consumerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'consumerPplId',
      header: 'Participant \nPPL ID',
      jsonpath: 'consumerPplId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
      isClickable: true
    },
    {
      field: 'providerName',
      header: 'Provider \nName',
      jsonpath: 'providerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'providerPplID',
      header: 'Provider \nPPL ID',
      jsonpath: 'providerPplID',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
      isClickable: true
    },
    {
      field: 'timeInTimeOut',
      header: 'Time In - \nTime Out',
      jsonpath: 'timeInTimeOut',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'clockInLoc',
      header: 'Clock In \nLocation',
      jsonpath: 'clockInLoc',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'clockOutLoc',
      header: 'Clock Out \nLocation',
      jsonpath: 'clockOutLoc',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnits',
      header: 'Billed \nHours',
      jsonpath: 'billedUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceRate',
      header: 'Service \nRate',
      jsonpath: 'serviceRate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'businessStatus',
      header: 'Business \nStatus',
      jsonpath: 'businessStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'processingStatus',
      header: 'Processing \nStatus',
      jsonpath: 'processingStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'source_type_lkp',
      header: 'Timesheet \nSource',
      jsonpath: 'source_type_lkp',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'mco_name',
      header: 'Regional \nCenter',
      jsonpath: 'mco_name',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'tasAuthorizationDetailId',
      header: 'Authorization \nNumber',
      jsonpath: 'tasAuthorizationDetailId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'associationStatus',
      header: 'CBA \nAssociation',
      jsonpath: 'associationStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    }
  ];

  fields = [
    { field: 'Timeframe', show: false, default: '30 days' },
    { field: 'consumer', show: true },
    { field: 'consumerPplId', show: true },
    { field: 'provider', show: true },
    { field: 'providerPplId', show: true },
    { field: 'payPeriod', show: true, hideFuturePeriods: true },
    { field: 'serviceCode', show: true },
    { field: 'serviceDate', show: true, hideFuturePeriods: true },
  ];

  keyMapping: { [key: string]: string } = {
    serviceDate: "serviceDate",
    payPeriod: "tasMasterPayrollScheduleId",
    consumer: "consumerName",
    consumerPplId: "consumerPplId",
    provider: "providerName",
    providerPplId: "providerPplId",
    chequeNumber: "chequeNumber",
    serviceCode: "serviceCodeDetailId"
  };

  constructor(
    private listService: ListService,
    private lookupService: LookupService,
    private dateTimeFormatterService: DateTimeFormatterService,
    private userService: UserService,
    private errorAlertService: ErrorAlertService
  ) { }

  // Handler for list-table view user events (clicking PPL IDs)
  onViewUserClicked = (payload: any) => {
    this.userService.setViewUserEvent({
      userId: payload.userId,
      isConsumer: payload.isConsumer
    });
  }

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
    this.businessStatusList = this.lookupService.getLookupValue('Business Status');
    this.processingStatusList = this.lookupService.getLookupValue('TS_App_S');
    this.serviceCodes = this.lookupService.getLookupValue('timesheet_filter_serviceCode');
    this.dispositionReason = this.lookupService.getLookupValue('Disposition Reason');
    this.timesheetDisposition = this.lookupService.getLookupValue('TimeSheet Disposition');
  }

  private setPageAccess() {
    const authConfig = this.allowListStore.getConfig();
    if (authConfig && !authConfig.pages[this.pageId]) {
      this.isReadOnly = true;
    }
  }

  searchTimesheets(filters: any, startingPageNumber = 1, currentPage = 0, recordsPerPage = 20) {
    this.hasSearched = true;

    const processedPayload = this.buildRequestPayload('staffEditTimesheetEntry', 'timesheetLineId', filters, startingPageNumber, recordsPerPage);

    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        const records = this.processData(data.responsedata);
        if (startingPageNumber > 1) {
          this.timesheets = [...this.timesheets, ...records];
        } else {
          this.timesheets = records;
        }
      });
  }

  buildRequestPayload(pageName: string, orderBy: string, searchParams: [], startingPageNumber = 1, recordsPerPage = 20) {
    if (searchParams.length == 0) {
      return;
    }

    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams,
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: ['desc'],
    };

    return payload;
  }

  processData(data: any) {
    if (data && data.length > 0) {
      data.forEach((element: any) => {
        element.timeInTimeOut = this.dateTimeFormatterService.convertTo12HourFormat(element.timeIn) + ' - ' + this.dateTimeFormatterService.convertTo12HourFormat(element.timeOut),
          element.businessStatus = this.businessStatusList.filter((status: any) => status.lkpValueCode === element.businessStatusLkp)
            .map((status: any) => status.lkpValueName),
          element.processingStatus = this.processingStatusList.filter((status: any) => status.lkpValueCode === element.processingStatusLkp)
            .map((status: any) => status.lkpValueName)

        // OTE entries are copied from the parent timesheet, so their time in/out and
        // clock locations carry no real meaning. Show them as '-' in the grid.
        if (CommonUtil.isOvertimeRow(element)) {
          element.timeInTimeOut = '-';
          element.clockInLoc = '-';
          element.clockOutLoc = '-';
        }
      });
    }

    return data;
  }

  onSearch(event: any) {
    const filters = [];

    if (event.serviceDate) {
      filters.push({
        jsonPath: "serviceDate",
        value: this.dateTimeFormatterService.formatDateToString(event.serviceDate as Date),
        operator: "Equal"
      });
    }

    if (event.payPeriod && event.payPeriod.length > 0) {
      filters.push({
        jsonPath: "tasMasterPayrollScheduleId",
        values: event.payPeriod,
        operator: "In"
      });
    }

    if (event.consumer && event.consumer.trim()) {
      filters.push({
        jsonPath: "consumerName",
        value: event.consumer.trim(),
        operator: "equal"
      });
    }

    if (event.consumerPplId && event.consumerPplId.trim()) {
      filters.push({
        jsonPath: "consumerPplId",
        value: event.consumerPplId.trim(),
        operator: "Equal"
      });
    }

    if (event.provider && event.provider.trim()) {
      filters.push({
        jsonPath: "providerName",
        value: event.provider.trim(),
        operator: "equal"
      });
    }

    if (event.providerPplId && event.providerPplId.trim()) {
      filters.push({
        jsonPath: "providerPplId",
        value: event.providerPplId.trim(),
        operator: "Equal"
      });
    }

    if (event.payPeriod) {
      filters.push({
        jsonPath: "tasMasterPayrollScheduleId",
        value: event.payPeriod,
        operator: "Equal"
      });
    }

    if (event.serviceCode) {
      filters.push({
        jsonPath: "serviceCodeDetailId",
        value: event.serviceCode,
        operator: "Equal"
      });
    }

    filters.push({
      jsonPath: "businessStatusLkp",
      value: 'D',
      operator: "Equal"
    });

    const hasRelevantFilter = filters.some(filter =>
      ["providerName", "consumerName", "providerPplId", "consumerPplId"].includes(filter.jsonPath)
    );


    this.appliedFilters = filters;
    this.searchTimesheets(filters, undefined, undefined, this.childComponent?.recordsPerPage ?? 20);
  }

  openWarningMessage() {
    const dialogConfig: DialogConfig = {
      title: 'Error',
      showOkButton: true,
      okText: 'Ok',
      size: 'medium',
      position: 'top',
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.searchFilterWarningDialog,
      dialogConfig,
      () => { },
      () => { }
    );
  }

  convertTimeStringToDate(timeString: string): Date {
    const currentDate = new Date();
    const [hours, minutes] = timeString.split(':');
    currentDate.setHours(Number(hours), Number(minutes), 0, 0);
    return currentDate;
  }

  areArraysEqual(a: any[], b: any[]): boolean {
    if (!Array.isArray(a) || !Array.isArray(b))
      return false;

    if (a.length !== b.length)
      return false;

    return a.every((val, i) => val === b[i]);
  }

  isFilterValid(timesheetFilterValues: any, searchCallbackFilterValues: any) {
    const activeFilters = Object.keys(timesheetFilterValues).filter(key => {
      const value = timesheetFilterValues[key];
      if (value === null || value === undefined)
        return false;

      if (typeof value === 'string' && value.trim() === '')
        return false;

      if (Array.isArray(value) && value.length === 0)
        return false;

      return true;
    });

    const userAppliedFilters = searchCallbackFilterValues.filter(
      (filter: any) => !['businessStatusLkp', 'serviceDuration'].includes(filter.jsonPath)
    );

    if (activeFilters.length !== userAppliedFilters.length)
      return false;

    return Object.entries(timesheetFilterValues)
      .filter(([_, value]) => value !== null && value !== "")
      .every(([key, value]: [any, any]) => {
        const mappedKey = this.keyMapping[key] || key;

        if (Array.isArray(value) && value.length === 0)
          return true;

        let comparisonValue: any;

        if (mappedKey === 'serviceDate') {
          comparisonValue = this.dateTimeFormatterService.formatDateToString(value as Date);
        }
        else if (mappedKey === 'serviceDuration') {
          comparisonValue = value.substr(0, value.indexOf(' '));
        } else {
          comparisonValue = value;
        };

        return searchCallbackFilterValues.some((filter: any) => filter.jsonPath === mappedKey &&
          (Array.isArray(filter.value || filter.values) ? this.areArraysEqual(filter.values, comparisonValue) :
            typeof filter?.value === 'string' ? filter?.value?.trim() === comparisonValue?.trim() : filter?.value === comparisonValue));
      });
  }

  gridAction(event: any) {
    const { button, selectedCheckBox } = event;

    if (!this.isFilterValid(this.timesheetFilterChildComponent.timesheetSearchForm.value, this.appliedFilters)) {
      const errorMessage = `Some filters are newly applied but the search is not performed. Kindly perform search with updated filter or remove the filter.`;
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (selectedCheckBox && selectedCheckBox.length === 0 && button.buttonAction === 'resurrectTimesheet') {
      const errorMessage = `Kindly select checkbox and then perform this action.`;
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (selectedCheckBox.length > 1 && button.buttonAction === 'resurrectTimesheet') {
      const errorMessage = `Resurrect operation can be performed on single timesheet at a time.`;
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (button) {
      switch (button.buttonAction) {
        case 'resurrectTimesheet': {
          const selectedTimesheet = selectedCheckBox[0];
          const selectedService = this.serviceCodes?.find(service => service.lkpValueCode === selectedTimesheet.serviceCodeDetailId.toString());
          this.timesheetData = {
            timesheetLineId: selectedTimesheet.timesheetLineId,
            serviceDate: selectedTimesheet.serviceDate,
            serviceCode: selectedService,
            authDesc: selectedTimesheet.authDesc,
            clockInLoc: selectedTimesheet.clockInLoc,
            clockOutLoc: selectedTimesheet.clockOutLoc,
            timeIn: selectedTimesheet.timeIn,
            timeOut: selectedTimesheet.timeOut,
            billedUnits: selectedTimesheet.billedUnits,
            providerPplID: selectedTimesheet.providerPplID,
            participantId: selectedTimesheet.participantId,
            providerId: selectedTimesheet.providerId
          };
          break;
        }
        case 'resurrectAllTimesheet': {
          if (selectedCheckBox.length > 0) {
            this.timesheetData = {
              timesheetLineIds: selectedCheckBox.map((entry: any) => entry.timesheetLineId)
            }
          }
          break;
        }
      }

      this.selectedAction = button;

      const dialogConfig: DialogConfig = {
        title: `Payroll ${button.button_label}`,
        size: 'medium',
        position: 'top',
        showClose: true,
        showButtons: false,
        styleClass: this.selectedAction?.buttonAction !== 'resurrectTimesheet' ? 'limit-dialog-width' : ''
      };

      this.resurrectDialog = this.dialogSvc.openDialog(
        this.timesheetResurrectDialog,
        dialogConfig,
        () => this.handleCancel(),
        () => this.handleCancel()
      );
    }
  }

  closeResurrectDialog() {
    this.timesheetData = {};
    if (this.resurrectDialog) {
      this.dialogSvc.closeDialog(this.resurrectDialog);
      this.resurrectDialog = null;
    }
  }

  handleCancel() {
    this.closeResurrectDialog();
  }

  timesheetResurrected(event: any) {
    this.closeResurrectDialog();
    this.searchTimesheets(this.appliedFilters, event.startingPageNumber, event?.first ?? 0, this.childComponent?.recordsPerPage ?? 20);
  }

  onPageLoad(event: any): void {
    this.searchTimesheets(this.appliedFilters, event.startingPageNumber, event?.first ?? 0, event.rows ?? 20);
  }

  rowClicked(event: any) {
    if ((event?.col?.field === 'processingStatus') && event.event?.processingStatus[0] === 'Denied') {
      const payload = {
        pageName: 'timesheet-processCode',
        programCode: this.programName,
        condition: 'and',
        recordsPerPage: 20,
        startingPageNumber: 1,
        searchParam: [
          {
            jsonPath: 'timesheetId',
            value: event.event.timesheetLineId,
            operator: 'Equal',
          },
        ],
        orderByColumn: ['id'],
        orderBy: ['desc'],
      };
      this.listService
        .getListData(payload, 'claims')
        .subscribe((data: any) => {
          this.deniedData = data.responsedata;
          this.deniedData.forEach((e: any) => {
            if (e.reasonLkp) {
              e.reason = this.dispositionReason.filter((d: any) => d.lkpValueCode == e.reasonLkp)[0].lkpValueName;
            }

            if (e.dispositionLkp) {
              e.disposition = this.timesheetDisposition.filter((d: any) => d.lkpValueCode == e.dispositionLkp)[0].lkpValueName
            }
          });
          this.openDeniedDialog();
        });
    }
  }

  openDeniedDialog() {
    const dialogConfig: DialogConfig = {
      title: `Denied Timesheet`,
      okText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.resurrectDeniedDialog = this.dialogSvc.openDialog(
      this.deniedDialog,
      dialogConfig,
      () => this.handleDeniedDialogCancel(),
      () => this.handleDeniedDialogCancel()
    );
  }

  handleDeniedDialogCancel() {
    if (this.resurrectDeniedDialog) {
      this.dialogSvc.closeDialog(this.resurrectDeniedDialog);
      this.resurrectDeniedDialog = null;
    }
  }
}
